'use client';
import { Ccontainer } from '@/components/ui/Ccontainer';
import { Ctext } from '@/components/ui/Ctext';
import { ContainerPreset } from '@/constants/componentPresets';
import { ColorType } from '@/theme/colors';
import { FontWeight } from '@/theme/typography';
import { pxToRem } from '@/theme/spacing';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import type { ReactElement } from 'react';
import { FakeCommentMessageContent } from './FakeCommentMessageContent';
import type { FakeCommentMessage } from './cfakecommentTypes';
interface FakeCommentBubbleProps {
    dataElScope: DataElScope;
    message: FakeCommentMessage;
    date: string;
    animationDelay: number;
    isMobile: boolean;
    bubbleRadius?: string | number;
}
export function FakeCommentBubble({ dataElScope, message, date, animationDelay, isMobile, bubbleRadius, }: FakeCommentBubbleProps): ReactElement {
    const messageIdentity = `${message.kind}-${date}`;
    return <div data-el={dataEl(dataElScope, 'Bubble/Root')} style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: 'fit-content',
            gap: pxToRem(4),
            marginTop: pxToRem(6),
        }}>
	            <Ccontainer preset={ContainerPreset.ModalCard} padding="14px 23px" display="inline-flex" flexDirection="column" gap={0} style={{
            maxWidth: 'fit-content',
            backdropFilter: 'blur(4px)',
            boxShadow: 'rgba(0, 0, 0, 0.5) 0px 5px 8px, rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset',
            ...(bubbleRadius && isMobile ? { borderRadius: bubbleRadius } : {}),
        }}>
                <FakeCommentMessageContent dataElScope={dataElScope} message={message} animationDelay={animationDelay} isMobile={isMobile}/>
            </Ccontainer>

	            <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
        }}>
	                <Ctext size={14} weight={FontWeight.Regular} color={ColorType.White} opacity={0.5}>
                    {date}
                </Ctext>
            </div>
        </div>
        ;
}
